import React, {Component} from 'react';
//import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import UpBanner from '../../TempWebPage/UpBanner/UpBanner';
import BGImage from '../../../Utilities/default.jpg'
import EditedStageArea from './EditedStageArea'
import {Prompt} from 'react-router-dom'
import EditContent from './EditContent/EditContent'
import EditAbstract from './EditAbstract/EditAbstract'
import ContentPreview from './ContentPreview'
import EventEditComplete from './EventEditComplete'
import NotFinishedPageWrapper from '../../FunctionArea/NotFinishedPageWrapper'
import {server_ip} from '../../../ipAddress'
import './EventCreateBody.css'


const wStyles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paperFullScreen: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
    },
    paperNormal: {
        padding: theme.spacing(2),
        display: 'flex',
        //overflow: 'scroll',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    scrollContent1:{
        height:2000,
        width:200,
        backgroundColor:"#e6f542",
    },
    scrollContent2:{
        height:2000,
        width:200,
        backgroundColor:"#2e82ff",
    },
    scrollContainer:{
        backgroundImage: `url(${BGImage})`,
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundSize: "cover",
        position:"relative",
        width:"100%",
       // height:"1000px",
        overflow:"scroll"
    },
    fixedUpHeader: {
        position:"sticky"
    },
    rightTopBoxArea:{
        position: "absolute",
        right: 2,
        top: 2,
        display: "flex",
    },
    textLinkLeft:{
        float:"left",
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },
    textLinkRight:{
        float:"right",
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },
    rightTopBox: {
        width:20,
        height:20,
        fontFamily: "Arial, Helvetica, sans-serif",
        cursor: "pointer",
        textAlign: "center",
        borderRadius: 5,
        backgroundColor:"#e6e6e6",
        color: "gray",
        '&:hover':{
            backgroundColor: "gray",
            color: "white",
        }
    },
    titleArea: {
        fontSize: 30,
        fontFamily: "Microsoft JhengHei",
    },
    sessionInfo:{
        fontSize: 30,
        fontFamily: "Microsoft JhengHei",
        backgroundColor:"red",
        color:"white",
        border:"1px solid",
        borderRadius:"5px",
        padding:"0px 10px 0px 10px",
    },
    input: {
        display: "none",
    },
});

class EventCreateBody extends Component {
    constructor(props) {
        super(props)
        this.state = {
            editMode:null,
            tempEventSysID:null,
            eventSysID:null,
            eventDurationDate:null,
            eventCreatedDate:null,
            editingStage:1,
            editComplete:false,
            showContentPreview:false,
            fullScreen:false,
            eventAbstractContent:null,
            bodySize:null,
            bodyHeight:null,
            compositionContainers:[],
            sessionInfo:null,
            showNotFinishedWrapper:false
        }
        this.openTempFile = React.createRef()     
    }

    componentDidMount(){
        if(this.props.userID)
        {
            this.checkEventSysID()
        }
        window.addEventListener("beforeunload",(e)=>{ 
            e.preventDefault()    
            return this.freeEventSession(this.props.match.params.Event_SysID)
        })
    }

    componentDidUpdate(prevProps){
        if(prevProps.userID !== this.props.userID && this.props.userID)
        {
            this.checkEventSysID()
        }    
    }

    componentWillUnmount(){
        window.removeEventListener("beforeunload", this.freeEventSession(this.props.match.params.Event_SysID))
    }

    getEventCreatedDate = (cDate) =>{
        let tYear = this.addZeroFirstAndToString(cDate.getFullYear())
        let tMonth = this.addZeroFirstAndToString(cDate.getMonth()+1)
        let tDate = this.addZeroFirstAndToString(cDate.getDate())
        let tHour = this.addZeroFirstAndToString(cDate.getHours())
        let tMinute = this.addZeroFirstAndToString(cDate.getMinutes())
        return tYear+tMonth+tDate+tHour+tMinute
    }

    addZeroFirstAndToString = (num) =>{
        let output = ''
        if(num<10)
        {
          output = '0'+num
        }
        else
        {
          output = String(num)
        }
        return output
    }

    checkEventSysID=()=>{
        let mode = this.props.match.params.Mode
        let eventSysID = this.props.match.params.Event_SysID
        console.log("checkEventSysID Event_SysID: ", eventSysID)
        console.log("checkEventSysID Mode: ", mode)

        this.checkAndLoadEventAbstractContent(mode,eventSysID)
       
    }

    checkAndLoadEventAbstractContent=async(mode, eventSysID)=>{
        if(mode === "Create")
        {
            this.initialState(mode,eventSysID,null,null)
        }
        else if(mode === "Edit")
        {
            let eventSessionResult = await this.checkEventSessionResult(eventSysID,this.props.userID)
            //// Link to api to check Event_SysID valid or not, if valid, then get the event abstract content from api....
            if(eventSessionResult.sessionAvaliable)
            {
                console.log("this event is avaliable !")
                this.setEventSession(eventSysID,this.props.userID)
                let eventAbstractObj = await this.fetchEventInfoFromAPI(eventSysID)
                let compositionContainers= await this.fetchEventCompositionFromAPI(eventSysID)
                this.initialState(mode, eventSysID, eventAbstractObj,compositionContainers,eventSessionResult)
            }
            else
            {
                console.log("this event is occupied !")
                let eventAbstractObj = await this.fetchEventInfoFromAPI(eventSysID)
                let compositionContainers= await this.fetchEventCompositionFromAPI(eventSysID)
                this.initialState(mode, eventSysID, eventAbstractObj,compositionContainers,eventSessionResult)
            }
        }
    }

    setEventSession=async(eventSysID,userID)=>{
        let tempBody = {
            'EventSysID':eventSysID,
            'UserID':userID
        }
        
        let msg = await fetch(server_ip+'/api/event/set/EventSession',{
            method:'PUT',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body:this.getEncodeFormBody(tempBody)
        })
        let output = await msg.json()
        console.log(output[0])
    }

    freeEventSession=async(eventSysID)=>{
        console.log('freeEventSession')
        if(this.state.sessionInfo && this.state.sessionInfo.sessionAvaliable)
        {
            let tempBody = {
                'EventSysID':eventSysID
            }

            let msg = await fetch(server_ip+'/api/event/free/EventSession',{
                method:'PUT',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body:this.getEncodeFormBody(tempBody)
            })
            //let output = await msg.json()
            console.log(msg.status)
        }      
    }

    getEncodeFormBody=(formObject)=>{
        let formBody =[]
        for (let property in formObject) 
        {
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(formObject[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        return formBody
    }

    checkEventSessionResult=async(eventSysID,userID)=>{
        let msg = await fetch(server_ip+'/api/event/check/EventSession/'+eventSysID)
        let output = await msg.json()
        console.log('checkEventSysID')
        console.log(output[0])
        if(output[0].EventSession === 0)
        {
            return {sessionAvaliable:true,sessionOccupier:null}
        }
        else
        {
            if(output[0].UserID === userID)
            {
                return {sessionAvaliable:true,sessionOccupier:null}
            }
            else
            {
                return {sessionAvaliable:false,sessionOccupier:output[0].UserName}
            }
        }
    }

    fetchEventInfoFromAPI=async(eventSysID)=>{
        let msg = await fetch(server_ip+'/api/event/fetch/EventAbstractInfo/'+eventSysID)
        let output = await msg.json()

        let tempAbstractObj = {
            Event_Images:output[0].Event_BGImageSettings,
            Event_Story:output[0].Event_Story,
            Event_SubTitle:output[0].Event_SubTitle, 
            Event_Title:output[0].Event_Title,
           
        }

        let outputMsg = {
            eventCreatedDate:output[0].Event_CreatedDate,
            eventDurationDate:{
                eventEndTime:output[0].Event_EndDate,
                eventStartTime:output[0].Event_StartDate
            },
            eventAbstractContent:tempAbstractObj
        }

        return outputMsg
    }

    fetchEventCompositionFromAPI = async(eventSysID)=>{
        let msg = await fetch(server_ip+'/api/event/fetch/EventComposition/'+eventSysID)
        let output = await msg.json()
        return output[0].Event_CompositionSettings
    }

    initialState=(mode,eventSysID,msg,compositionContainers,sessionStatus)=>{
        if(mode === "Create")
        {
            let tempEventAbstractContent
            if(msg)
            {
                tempEventAbstractContent = msg.eventAbstractContent
            }
            else
            {
                tempEventAbstractContent = null
            }
            this.setState({
                editMode:mode,
                tempEventSysID:eventSysID,
                eventAbstractContent:tempEventAbstractContent,
                sessionInfo:sessionStatus
            })
            
        }
        else if(mode === "Edit")
        {
            this.setState({
                editMode:mode,
                eventSysID:eventSysID,
                eventCreatedDate:msg.eventCreatedDate,
                eventDurationDate:msg.eventDurationDate,
                eventAbstractContent:msg.eventAbstractContent,
                compositionContainers:compositionContainers,
                sessionInfo:sessionStatus
            })
        }
    }

    openFileLoadingDialog = () => {
        this.openTempFile.current.click()
    }

    fullScreenBoxOnClick = (e) => {
        e.stopPropagation()
        this.setState(prevState=>({
            fullScreen:!prevState.fullScreen
        }))
    }

    changeEditingStage=(msg)=>{
        if(this.state.editingStage !== msg)
        {
            this.setState({
                editingStage:msg
            })
        }
    }

    previewToggle=()=>{
        this.setState({
            showContentPreview: !this.state.showContentPreview
        })
    }

    getEventAbstract=(msg)=>{
        //console.log("EventCreateBody getEventAbstract : ")
        //console.log(msg)
        if(this.state.eventAbstractContent !== msg)
        {
            this.setState({
                eventAbstractContent:msg
            })
        }
    }

    getEventContent=(msg)=>{
        if(this.state.compositionContainers !== msg.compositionContainers || this.state.bodySize !== msg.bodySize)
        {
            this.setState({
                compositionContainers:msg.compositionContainers,
                bodySize:msg.bodySize,
                bodyHeight:msg.bodyHeight
            })
        }
        else if(this.state.compositionContainers === null)
        {
            this.setState({
                compositionContainers:msg.compositionContainers,
                bodySize:msg.bodySize,
                bodyHeight:msg.bodyHeight
            })
        }
    }

    getEventDurationDate=(msg)=>{
        if(msg !== this.state.eventDurationDate)
        {
            this.setState({
                eventDurationDate:msg
            })
        }
    }



    showAbstractAreaOrContentArea=()=>{
        if(this.state.showContentPreview)
        {
            return  <ContentPreview compositionContainers={this.state.compositionContainers} bodySize={this.state.bodySize} bodyHeight={this.state.bodyHeight} previewToggle={this.previewToggle}/>
        }
        else
        {
            if(this.state.editingStage ===1)
            {
                return <EditAbstract fullScreen={this.state.fullScreen} eventAbstract={this.state.eventAbstractContent} getEventAbstract={this.getEventAbstract}/>
            }
            else if(this.state.editingStage ===2)
            {
                return <EditContent fullScreen={this.state.fullScreen} eventContent={this.state.compositionContainers} getEventContent={this.getEventContent}/>
            }
            else if(this.state.editingStage ===3)
            {
                return <EventEditComplete eventSysID={this.state.eventSysID} tempEventSysID={this.state.tempEventSysID} eventDurationDate={this.state.eventDurationDate} eventAbstract={this.state.eventAbstractContent} eventSession={this.state.sessionInfo? this.state.sessionInfo.sessionAvaliable:true} fieldCheck={this.allFieldsCheck()} getEventDurationDate={this.getEventDurationDate} postEvent={this.postEvent}/>
            }
        }
    }

    showLeaveWarningPrompt=()=>{
        if(this.state.sessionInfo && this.state.sessionInfo.sessionAvaliable)
        {
            if(this.state.editComplete)
            {
                return null
            }
            else
            {
                return <Prompt message={"將離開編輯專題頁面，未儲存之資料將遺失! 您確定要離開此頁面嗎?"}/>
            }
        }
        else
        {
            return null
        }
    }

    showSessionInfoArea=()=>{
        const {classes} = this.props;
        if(this.state.sessionInfo && !this.state.sessionInfo.sessionAvaliable)
        {
            console.log()
            return <div className={classes.sessionInfo}>此專題 <span style={{backgroundColor:"blue",color:"white"}}>{this.state.sessionInfo.sessionOccupier}</span>正在編輯，目前僅能檢視，所做任何變更均不會儲存</div>
        }
        else
        {
            return null
        }
    }

    allFieldsCheck=()=>{
        let checkResult = {
            eventAbstractContentCheck:this.eventAbstractContentCheck(),
            compositionContainersCheck : this.compositionContainersCheck(),
            eventDateCheck:this.eventDateCheck()
        }

        return checkResult
    }

    compositionContainersCheck=()=>{
        let compositionContainersCheckResult = true
        if(this.state.compositionContainers)
        {
            if(this.state.compositionContainers.length === 0)
            {
                compositionContainersCheckResult = false
            }
            else
            {
                this.state.compositionContainers.forEach((composition)=>{
                    if(composition.type === "image")
                    {
                        if(!composition.imageAttributes)
                        {
                            compositionContainersCheckResult = false
                        }
                        else
                        {
                            if(!composition.imageAttributes.imageUrl)
                            {
                                compositionContainersCheckResult = false
                            }
                        }
                    }
                    else if(composition.type === "text")
                    {
                        if(!composition.textAttributes)
                        {
                            compositionContainersCheckResult = false
                        }
                    }
                })
            }
        }
        else
        {
            compositionContainersCheckResult = false
        }
        

        return compositionContainersCheckResult
    }


    eventAbstractContentCheck=()=>{
        let eventAbstractContentCheckResult = true
        if(!this.state.eventAbstractContent)
        {
            //console.log("z1")
            eventAbstractContentCheckResult = false
        }
        else
        {
            //console.log("z2")

            if(this.state.eventAbstractContent.Event_Images)
            {
                //console.log("z2-1")
                if(this.state.eventAbstractContent.Event_Images.length===0)
                {
                    //console.log("z2-1-1")
                    eventAbstractContentCheckResult = false
                }
            }
            else if(this.state.eventAbstractContent.Event_Images === null)
            {
                //console.log("z2-2")
                eventAbstractContentCheckResult = false
            }
            else if(this.state.eventAbstractContent.Event_Title === "專題標題")
            {
                //console.log("z2-3")
                eventAbstractContentCheckResult = false
            }
            else if(this.state.eventAbstractContent.Event_SubTitle === "專題副標題")
            {
                //console.log("z2-4")
                eventAbstractContentCheckResult = false
            }
            else if(this.state.eventAbstractContent.Event_Story === "專題介紹:請於此處編寫專題之簡介")
            {
                //console.log("z2-5")
                eventAbstractContentCheckResult = false
            }
        }
        return eventAbstractContentCheckResult
    }

    eventDateCheck=()=>{
        let eventDurationDateCheckResult = true
        if(!this.state.eventDurationDate)
        {
            console.log("dateCheck A1")
            eventDurationDateCheckResult = false
        }
        else
        {
            console.log("dateCheck A2")
            let sDate = new Date(this.state.eventDurationDate.eventStartTime)
            let eDate = new Date(this.state.eventDurationDate.eventEndTime)
            if(sDate>eDate)
            {
                console.log("dateCheck A2-1")
                eventDurationDateCheckResult = false
            }
            else if(sDate.getTime() === eDate.getTime())
            {
                console.log("dateCheck A2-2")
                eventDurationDateCheckResult = false
            }
        }

        return eventDurationDateCheckResult
    }

    postEvent=async()=>{
        let cDate = new Date()
        let outputEventSysID
        if(this.state.editMode === "Create")
        {
            outputEventSysID = this.getEventCreatedDate(cDate)+this.props.userID
        }
        else if(this.state.editMode === "Edit")
        {
            outputEventSysID = this.state.eventSysID
        }

        if(this.state.eventAbstractContent)
        {
            if(this.state.eventAbstractContent.Event_Images.length >0)
            {
                let abstractBGImagesPromises = new Promise((resolve,reject) =>{
                    let abstractBGImages = this.state.eventAbstractContent.Event_Images.filter((image)=>{
                        let urlPrefix = image.imageUrl.substr(0,4)
                        if(urlPrefix === "blob")
                        {
                            //console.log("True Url : ", image.imageUrl, urlPrefix)
                            return true
                        }
                        else
                        {
                            //console.log("False Url : ", image.imageUrl, urlPrefix)
                            return false
                        }

                    }).map(async(image)=>{
                            let blobB = await fetch(image.imageUrl).then(r=>r.blob())
                            //console.log("A1")
                            let fileItem = {
                                file:blobB,
                                imageID:image.imageID
                            }
                            return fileItem      
                    })         
                    resolve(Promise.all(abstractBGImages))
                })

                let compositionImagesPromises = new Promise((resolve,reject)=>{
                    let compositionImages = this.state.compositionContainers.filter((compositionContainer)=>{                    
                        if(compositionContainer.type === "image")
                        {
                            let urlPrefix = compositionContainer.imageAttributes.imageUrl.substr(0,4)
                            if(urlPrefix === "blob")
                            {
                                return true
                            }
                            else
                            {
                                return false
                            }
                        }
                        else
                        {
                            return false
                        }
                    }).map(async(compositionContainer)=>{
                        //console.log("A7")
                        let blobC = await fetch(compositionContainer.imageAttributes.imageUrl).then(r=>r.blob())
                        let fileItem = {
                            file:blobC,
                            imageID:compositionContainer.conID
                        }
                        return fileItem
                    })
                    resolve(Promise.all(compositionImages))
                })

                let abstractBGImageJsonStringfy = new Promise((resolve,reject)=>{
                    let myJson = JSON.stringify(this.state.eventAbstractContent.Event_Images)
                    resolve(myJson)
                })

                let compositionJsonStringfy = new Promise((resolve,reject)=>{
                    let myJson = JSON.stringify(this.state.compositionContainers)
                    resolve(myJson)
                })
               
                Promise.all([abstractBGImagesPromises,compositionImagesPromises,abstractBGImageJsonStringfy,compositionJsonStringfy]).then(async(promiseArray)=>{
                    let formData = new FormData()
                    let createdDateToken
                    if(this.state.editMode === "Create")
                    {
                        createdDateToken = cDate.toISOString().slice(0, 19).replace('T', ' ')
                    }
                    else if(this.state.editMode === "Edit")
                    {
                        createdDateToken = this.state.eventCreatedDate
                    }

                    console.log(promiseArray)
                    promiseArray[0].forEach(file=>{

                        let extendName = ""
                        if(file.file.type === "image/gif")
                        {
                            extendName = ".gif"
                        }
                        else if(file.file.type === "image/tiff")
                        {
                            extendName = ".tiff"
                        }
                        else if(file.file.type === "image/jpeg")
                        {
                            extendName = ".jpeg"
                        }
                        else if(file.file.type === "image/png")
                        {
                            extendName = ".png"
                        }


                        formData.append("eventAbstractBgImages", file.file, file.imageID+extendName)
                    })
                    promiseArray[1].forEach(file=>{
                        let extendName = ""
                        if(file.file.type === "image/gif")
                        {
                            extendName = ".gif"
                        }
                        else if(file.file.type === "image/tiff")
                        {
                            extendName = ".tiff"
                        }
                        else if(file.file.type === "image/jpeg")
                        {
                            extendName = ".jpeg"
                        }
                        else if(file.file.type === "image/png")
                        {
                            extendName = ".png"
                        }
                        formData.append("eventCompositionImages", file.file, file.imageID+extendName)
                    })

                    formData.append("EventBGImageSettingArray",promiseArray[2])
                    formData.append("EventCompositionSettingArray",promiseArray[3])
                    formData.append("Event_SysID", outputEventSysID)
                    formData.append("Event_Title", this.state.eventAbstractContent.Event_Title)
                    formData.append("Event_UserID", this.props.userID)
                    formData.append("Event_SubTitle", this.state.eventAbstractContent.Event_SubTitle)
                    formData.append("Event_Story", this.state.eventAbstractContent.Event_Story)
                    formData.append("Event_CreatedDate", createdDateToken)
                    formData.append("Event_StartDate", this.state.eventDurationDate.eventStartTime)
                    formData.append("Event_EndDate", this.state.eventDurationDate.eventEndTime)

                    let editModeToken

                    if(this.state.editMode === "Create")
                    {
                        editModeToken = "post"
                    }
                    else if(this.state.editMode === "Edit")
                    {
                        editModeToken = "put"
                    }

                    let msg = await fetch(server_ip+'/api/eventEdit/'+editModeToken, {
                        body:formData,
                        method:editModeToken
                    })
      
                    let output = await msg
                    console.log(output)
                    if(output.statusText === "OK")
                    {
                        this.setState({
                            editComplete:true
                        },()=>{
                            this.props.history.push("/EventManagement/Default")
                        })
                    }
                })
            }
        }
    }

    cancelEvent=()=>{
        console.log("cancelEvent...")
        this.props.history.push("/EventManagement/Default")
    }

    getEditModeTitle=()=>{
        if(this.state.editMode === "Create")
        {
            return "新增專題 : 暫時識別號 "+this.state.tempEventSysID
        }
        else if(this.state.editMode === "Edit")
        {
            return "編輯專題 : 識別號 "+this.state.eventSysID
        }
    }


    render(){
        const {classes} = this.props;

        let parentFullScreen = {
            width:'100vw',
            height:'100vh',
            position:'fixed',
            left:'0',
            top:'0',
            zIndex:'2000',
            backgroundColor:'white'   
        }

        let parentNotFullScreen = {
            backgroundColor:'white',
            //height:'80vh'
        }

        let childFullScreen = {
            position:"absolute",
            width:"100%",
            height:"100%",
            overflow:"scroll"
        }

        let childNotFullScreen = {
            flexDirection:"column",
            display:"flex"
        }

        let headerFullScreen = {
            position:"fixed",
            zIndex:200,
            backgroundColor:"white",
            width:"100%"
        }

        let headerNotFullScreen = {
            top:"0px",
            position:"sticky",
            zIndex:200,
            backgroundColor:"white",
            width:"100%"
        }

        let maskNotFullScreen = {
        //    top:"95px",
        //    backgroundColor:"white",
        //    zIndex:"150",
        //    width:"100%",
        //    height:"20px",
        //    position:"fixed"
        }

        let fullScreenSymbol = "☐"
        let notFullScreenSymbol = "_"

        return (
            <main className={classes.content}>
                {this.showLeaveWarningPrompt()}
                <div className={classes.appBarSpacer} />
                {this.state.showNotFinishedWrapper?<NotFinishedPageWrapper closeModal={()=>this.setState({showNotFinishedWrapper:false})}/>:null}
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Paper className={this.state.fullScreen?classes.paperFullScreen:classes.paperNormal}>  
                                <div style={this.state.fullScreen? parentFullScreen:parentNotFullScreen}>
                                <div style={this.state.fullScreen? childFullScreen:childNotFullScreen}> 
                                    <div className={classes.fixedUpHeader} style={this.state.fullScreen? headerFullScreen:headerNotFullScreen}>
                                        <div className ={classes.rightTopBoxArea}>
                                            <div className = {classes.rightTopBox} onClick={this.fullScreenBoxOnClick}>{this.state.fullScreen? notFullScreenSymbol:fullScreenSymbol}</div>
                                        </div>
                                        <div style={{display:"flex"}}> 
                                            <div className={classes.titleArea}>{this.getEditModeTitle()}</div>  
                                            {this.showSessionInfoArea()}
                                        </div>
                                        <div>
                                            <input className={classes.input} type={"file"} ref={this.openTempFile}/>  
                                            <Button className={classes.textLinkLeft} startIcon={<FolderOpenIcon />} onClick={()=>this.setState({showNotFinishedWrapper:true})}>
                                                開啟專題暫存檔
                                            </Button>
                                            <Button className={classes.textLinkLeft} startIcon={<SaveIcon />} onClick={()=>this.setState({showNotFinishedWrapper:true})}>
                                                暫存專題
                                            </Button>    
                                            <EditedStageArea editingStage={this.state.editingStage} changeEditingStage={this.changeEditingStage}/>
                                            <Button className={classes.textLinkRight} startIcon={<DeleteIcon />} onClick={this.cancelEvent}>
                                                結束編輯
                                            </Button>
                                            <Button className={classes.textLinkRight} startIcon={<LocalPrintshopIcon />} onClick={()=>this.setState({showNotFinishedWrapper:true})}>
                                                輸出頁面
                                            </Button>  
                                            <Button className={classes.textLinkRight} startIcon={<DesktopWindowsIcon />} onClick={this.previewToggle}>
                                                頁面預覽
                                            </Button>
                                        </div>
                                        {this.state.editingStage === 3 ? null :<div className={"UpHeader"}><UpBanner /><div className={"StaticPageBanner"}></div></div>}
                                    </div>
                                    <div style={maskNotFullScreen}/> 
                                    {this.showAbstractAreaOrContentArea()}
                                </div>
                                </div>
                            </Paper>                
                        </Grid>
                    </Grid>
                </Container>
            </main>
        )  
    }
}

export default withStyles(wStyles)(EventCreateBody)
